import { ReactNode } from "react";
import { ApplicationError, ErrorCode, getErrorMessage, isApplicationError } from "../../data-types";
import { NotificationInstance } from "antd/lib/notification";

export type AlertMessageType = keyof NotificationInstance;

export type AlertMessage = {
  type: AlertMessageType;
  message: ReactNode;
  description?: ReactNode;
  cause?: ApplicationError;
  onClose?: () => void;
  closable?: boolean;
};

export function newAlertMessage(
  type: AlertMessageType,
  message: ReactNode,
  description?: ReactNode,
  cause?: ApplicationError,
  onClose?: () => void
) {
  return {
    type,
    message,
    description,
    cause,
    onClose,
  };
}

export function newErrorAlertMessage(
  error: any,
  message?: ReactNode,
  description?: ReactNode,
  onClose?: () => void
) {
  return newAlertMessage(
    "error",
    message || messageFromError(error, "Unknown Error"),
    description || descriptionFromError(error),
    isApplicationError(error) ? error : undefined,
    onClose
  );
}

function messageFromError(error: any, defaultMessage: string): string {
  return isApplicationError(error) && error.code in MESSAGE_BY_ERROR_CODE
    ? MESSAGE_BY_ERROR_CODE[error.code]
    : getErrorMessage(error) || defaultMessage;
}

function descriptionFromError(error: any): string | undefined {
  return isApplicationError(error) && error.code in DESCRIPTION_BY_ERROR_CODE
    ? MESSAGE_BY_ERROR_CODE[error.code]
    : undefined;
}

const MESSAGE_BY_ERROR_CODE: Record<ErrorCode, string> = {
  ["UNKNOWN_ERROR"]: "Error",
  ["NETWORK_ERROR"]: "Network Error",
  ["SERVER_ERROR"]: "Server Error",
};

const DESCRIPTION_BY_ERROR_CODE = {
  ["NETWORK_ERROR"]: "Please check your internet connection",
};
